export enum Layers {
    TALL_TREES = "0",
    SMALL_TREES = "1",
    SHRUBS = "2",
    VEGETABLES = "3",
    GROUND = "4"
}

export enum Crops {
    FRUIT = "fruit",
    NUT = "nut",
    BERRY = "berry",
    SALAD = "salad",
    VEGETABLE = "vegetable",
    DRINK = "drink",
    HERB = "herb",
    ROPE = "rope"
}

export enum Systems {
    BEES = "bees",
    ACCUMULATOR = "accumulator",
    NITROGEN = "nitrogen"
}
